import { render } from "./Confidentialite.vue?vue&type=template&id=594e2189&scoped=true"
const script = {}

import "./Confidentialite.vue?vue&type=style&index=0&id=594e2189&scoped=true&lang=css"

import exportComponent from "/var/www/ca-quiz.staging.mindoza.net/releases/20240705152708/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594e2189"]])

export default __exports__